import { render, staticRenderFns } from "./LastBookingSettings.vue?vue&type=template&id=3d62af66&"
import script from "./LastBookingSettings.vue?vue&type=script&lang=ts&"
export * from "./LastBookingSettings.vue?vue&type=script&lang=ts&"
import style0 from "./LastBookingSettings.vue?vue&type=style&index=0&id=3d62af66&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports